module.exports = __webpack_public_path__ + "1ee936d63baf99237466948e949a9744.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/hoodie-finger-heart-brown.png
// module id = 1863
// module chunks = 0